import { Badge } from '@talentmesh/ui/components/badge';
import { TypographyP } from '@talentmesh/ui/components/typography';
import React from 'react';
import { isMobile } from 'react-device-detect';

interface ChipCloudProps {
    chips: Array<string>;
    label?: string;
}

function ChipCloud({ chips, label }: ChipCloudProps): React.JSX.Element {
    return (
        <div className="flex flex-col gap-2">
            {label && <TypographyP className="text-base">{label}</TypographyP>}
            <div className={`flex flex-row flex-wrap items-start gap-2 ${isMobile ? 'gap-x-1' : ''}`}>
                {chips.map((chip) => (
                    <Badge key={chip} className="bg-blueish text-blueish-foreground rounded-md">
                        {chip}
                    </Badge>
                ))}
            </div>
        </div>
    );
}

export default ChipCloud;
